// Бутоните на редизайнатите страници в склада — едни и същи класове навсякъде
// (хедър, футър, модали), за да не се разминават отстъпите и hover-ът.
// focus-visible пръстенът е нужен: antd reset-ът маха outline-а на бутоните.

const FOCUS_RING =
  "outline-none focus-visible:shadow-[0_0_0_3px_var(--color-brand-tint)]";

// Основното действие на екрана (кехлибарено, плътно)
export const PRIMARY_BUTTON_CLASS =
  `inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-[9px] border-none bg-brand px-[18px] py-2.5 text-[13.5px] font-bold leading-[normal] text-white shadow-[0_1px_3px_rgba(217,127,0,0.4)] hover:bg-brand-deep disabled:cursor-not-allowed disabled:opacity-55 ${FOCUS_RING}`;

// Второстепенно действие (бял бутон с рамка)
export const SECONDARY_BUTTON_CLASS =
  `inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-shade-3 bg-surface px-3.5 py-2 text-[13px] font-medium leading-[normal] text-ink hover:border-shade-5 disabled:cursor-not-allowed disabled:opacity-55 ${FOCUS_RING}`;

// Деструктивно действие без фон (Анулирай, Изтрий черновата)
export const DANGER_TEXT_BUTTON_CLASS =
  `inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-lg border-none bg-transparent px-2.5 py-2 text-[13.5px] font-medium leading-[normal] text-danger-ink hover:bg-danger-tint ${FOCUS_RING}`;

// Деструктивно основно действие (потвърждението в модала „Анулирай")
export const DANGER_BUTTON_CLASS =
  `inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-[9px] border-none bg-danger px-[18px] py-2.5 text-[13.5px] font-bold leading-[normal] text-white hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-55 ${FOCUS_RING}`;

// Текстов бутон-линк (Изчисти, Покажи още)
export const LINK_BUTTON_CLASS =
  `cursor-pointer border-none bg-transparent p-0 text-[12.5px] leading-[normal] text-body underline hover:text-ink ${FOCUS_RING}`;
